import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FormLabelWrapper, TextInput } from '@restworld/ui-ds-base';
import { TermsAndConditions } from '../../../legacy';

import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';
import { useBasicProfileInformation } from '../../worker-application-wizard.constants';
import { WizardStepProps } from '../../worker-application-wizard.types';
import { HelperTextRElement } from '../form-inputs';
import { PhoneNumberField } from './wizard-third-step';
import { AlreadyUsedLoginHelperText } from './already-used-login-helper-text';
import { useWizardShowsSignupBoxes } from '../form-inputs.hooks/use-wizard-signup-boxes';

export const WizardInitialStep: React.FunctionComponent<WizardStepProps> = () => {
  const { errorsTextMap, conflictFields } = useWorkerApplicationCxt();
  const { control, watch, setValue } = useFormContext();
  const showsSignupBoxes = useWizardShowsSignupBoxes();
  const basicProfileInformation = useBasicProfileInformation();
  return (
    <div className="flex flex-col gap-4">
      {basicProfileInformation?.map(({ key, rules, title, type, placeholder }, i) => {
        const helperText: string = errorsTextMap[key];
        let customHelperText = <HelperTextRElement helperText={helperText} />;
        // Only a field the backend named as already taken gets the "log in instead" way out.
        // This used to fire on any field once a conflict had been seen, which is how a phone
        // conflict came out as "e-mail already used" on the e-mail input.
        if (key === 'email' && conflictFields.includes(key) && helperText) {
          customHelperText = <AlreadyUsedLoginHelperText key={`${key}-helper-text-${i}`} field="email" />;
        }
        if (key === 'phone_number') return <PhoneNumberField key={`${key}-phone-number-${i}`} />;
        return (
          <FormLabelWrapper key={key + i} id={key} label={title}>
            <Controller
              name={key}
              control={control}
              rules={rules}
              render={({ field }) => (
                <TextInput
                  id={key}
                  placeholder={placeholder}
                  type={type}
                  helperText={customHelperText}
                  color={helperText ? 'failure' : undefined}
                  data-cy={`${key}-input`}
                  key={`${key}-input-${i}`}
                  {...field}
                />
              )}
            />
          </FormLabelWrapper>
        );
      })}
      {showsSignupBoxes && (
        <div className="pt-4">
          <Controller
            name="tAndC"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TermsAndConditions
                isChecked={field.value}
                onCheckboxChange={(e) => field.onChange(e.target.checked)}
                iserror={errorsTextMap['tAndC']}
                marketingChecked={!!watch('marketingAndTracking')}
                onMarketingChange={(checked) => setValue('marketingAndTracking', checked)}
              />
            )}
          />
        </div>
      )}
    </div>
  );
};
export default WizardInitialStep;
